import { push } from 'react-router-redux';
import budgetApi from '../api/budgetApi';
import routePaths from '../routePaths';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import history from '../history';

export const types = {
  GET_BUDGET_WITH_MY_APPLICATION: 'GET_BUDGET_WITH_MY_APPLICATION',
  GET_BUDGET_WITH_MY_APPLICATION_SUCCESS: 'GET_BUDGET_WITH_MY_APPLICATION_SUCCESS',
  GET_BUDGET_WITH_MY_APPLICATION_FAILURE: 'GET_BUDGET_WITH_MY_APPLICATION_FAILURE',
  GET_MY_APPLICATIONS: 'GET_MY_APPLICATIONS',
  GET_MY_APPLICATIONS_SUCCESS: 'GET_MY_APPLICATIONS_SUCCESS',
  GET_MY_APPLICATIONS_FAILURE: 'GET_MY_APPLICATIONS_FAILURE',
  GET_BUDGET: 'GET_BUDGET',
  GET_BUDGET_SUCCESS: 'GET_BUDGET_SUCCESS',
  GET_BUDGET_FAILURE: 'GET_BUDGET_FAILURE',
  APPLICATION_SUBMIT: 'APPLICATION_SUBMIT',
  APPLICATION_SUCCESS: 'APPLICATION_SUCCESS',
  APPLICATION_FAILURE: 'APPLICATION_FAILURE',
  APPLICATION_SAVE: 'APPLICATION_SAVE',
  APPLICATION_SAVE_SUCCESS: 'APPLICATION_SAVE_SUCCESS',
  APPLICATION_SAVE_FAILURE: 'APPLICATION_SAVE_FAILURE',
  GET_VOTE_SETTINGS: 'GET_VOTE_SETTINGS',
  GET_VOTE_SETTINGS_SUCCESS: 'GET_VOTE_SETTINGS_SUCCESS',
  GET_VOTE_SETTINGS_FAILURE: 'GET_VOTE_SETTINGS_FAILURE',
  BUDGET_VOTE_SUBMIT: 'BUDGET_VOTE_SUBMIT',
  BUDGET_VOTE_SUCCESS: 'BUDGET_VOTE_SUCCESS',
  BUDGET_VOTE_FAILURE: 'BUDGET_VOTE_FAILURE',
  BUDGET_VOTE_ERROR: 'BUDGET_VOTE_ERROR',
  CLEAR_BUDGET_VOTE_ERROR: 'CLEAR_BUDGET_VOTE_ERROR',
  GET_BUDGET_APPLICATION_DETAILS: 'GET_BUDGET_APPLICATION_DETAILS',
  GET_BUDGET_APPLICATION_DETAILS_SUCCESS: 'GET_BUDGET_APPLICATION_DETAILS_SUCCESS',
  GET_BUDGET_APPLICATION_DETAILS_FAILURE: 'GET_BUDGET_APPLICATION_DETAILS_FAILURE',
  APPLICATION_SUPPORT_SUBMIT: 'APPLICATION_SUPPORT_SUBMIT',
  APPLICATION_SUPPORT_SUBMIT_SUCCESS: 'APPLICATION_SUPPORT_SUBMIT_SUCCESS',
  APPLICATION_SUPPORT_SUBMIT_FAILURE: 'APPLICATION_SUPPORT_SUBMIT_FAILURE',
  APPLICATION_CHANGES_SUBMIT: 'APPLICATION_CHANGES_SUBMIT',
  APPLICATION_CHANGES_SUCCESS: 'APPLICATION_CHANGES_SUCCESS',
  APPLICATION_CHANGES_FAILURE: 'APPLICATION_CHANGES_FAILURE',
};

function storeBlobAs(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  if (typeof link.download === 'string') {
    document.body.appendChild(link);
    link.download = filename;
    link.href = url;
    link.click();
    document.body.removeChild(link);
  } else {
    location.replace(url);
  }
}

export const actions = {
  load: () => dispatch => {
    dispatch({ type: types.GET_BUDGET });
    return budgetApi.getCurrent().then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_BUDGET_SUCCESS, budget: res.data });
      } else {
        dispatch({ type: types.GET_BUDGET_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać informacji o budżecie'));

        return logger.error(res.data);
      }
    });
  },
  loadApplicationDetails: (_, applicationId) => dispatch => {
    dispatch({ type: types.GET_BUDGET_APPLICATION_DETAILS });
    return budgetApi.getApplicationDetails(applicationId).then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_BUDGET_APPLICATION_DETAILS_SUCCESS, data: res.data });
      } else {
        dispatch({ type: types.GET_BUDGET_APPLICATION_DETAILS_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać informacji o projekcie'));

        return logger.error(res.data);
      }
    });
  },
  loadMyApplications: () => dispatch => {
    dispatch({ type: types.GET_MY_APPLICATIONS });
    return budgetApi.getMyApplications().then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_MY_APPLICATIONS_SUCCESS, applications: res.data });
      } else {
        dispatch({ type: types.GET_MY_APPLICATIONS_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać informacji o projektach'));

        return logger.error(res.data);
      }
    });
  },
  loadBudgetWithMyApplication: (id) => dispatch => {
    dispatch({ type: types.GET_BUDGET_WITH_MY_APPLICATION });
    return budgetApi.getBudgetWithMyApplication(id).then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_BUDGET_WITH_MY_APPLICATION_SUCCESS, budget: res.data });
      } else {
        dispatch({ type: types.GET_BUDGET_WITH_MY_APPLICATION_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać informacji o projektach'));

        return logger.error(res.data);
      }
    });
  },
  loadVoteFormSettings: () => dispatch => {
    dispatch({ type: types.GET_VOTE_SETTINGS });
    return budgetApi.loadVoteFormSettings().then(res => {
      if (res.ok) {
        dispatch({ type: types.GET_VOTE_SETTINGS_SUCCESS, data: res.data });
      } else {
        dispatch({ type: types.GET_VOTE_SETTINGS_FAILURE });
        dispatch(notificationActions.showError('Nie udało się pobrać informacji o budżecie'));

        return logger.error(res.data);
      }
    });
  },

  submitApplication: (budgetId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_SUBMIT });
    return budgetApi
      .submitApplication(budgetId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SUCCESS });
          return response.data.id;
        } else {
          dispatch({ type: types.APPLICATION_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },
  submitApplicationSupport: (budgetId, applicationId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_SUPPORT_SUBMIT });
    return budgetApi
      .submitApplicationSupport(budgetId, applicationId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SUPPORT_SUBMIT_SUCCESS });
          return true;
        } else {
          if (response.status === 400) {
            return false;
          }
          
          dispatch({ type: types.APPLICATION_SUPPORT_SUBMIT_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },
  createDraftApplication: (budgetId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_SAVE });
    return budgetApi
      .createDraftApplication(budgetId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SAVE_SUCCESS, id: response.data.id });
          history.push(routePaths.budgetSavedApplication.replace(':id', response.data.id));
          return;
        } else {
          dispatch({ type: types.APPLICATION_SAVE_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },
  updateDraftApplication: (budgetId, applicationId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_SAVE });
    return budgetApi
      .updateDraftApplication(budgetId, applicationId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SAVE_SUCCESS });
          return;
        } else {
          dispatch({ type: types.APPLICATION_SAVE_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },
  submitDraftApplication: (budgetId, applicationId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_SUBMIT });
    return budgetApi
      .submitDraftApplication(budgetId, applicationId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SUCCESS });
          return;
        } else {
          dispatch({ type: types.APPLICATION_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },

  submitApplicationChanges: (budgetId, applicationId, data) => dispatch => {
    dispatch({ type: types.APPLICATION_CHANGES_SUBMIT });
    return budgetApi
      .submitApplicationChanges(budgetId, applicationId, data)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_CHANGES_SUCCESS });
          history.push(routePaths.myBudgetApplications);
          return;
        } else {
          dispatch({ type: types.APPLICATION_CHANGES_FAILURE });
          dispatch(notificationActions.showError(`Zapis zmian nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },

  submitManualApplication: (budgetId, data, token) => dispatch => {
    dispatch({ type: types.APPLICATION_SUBMIT });
    return budgetApi
      .submitManualApplication(budgetId, data, token)
      .then(response => {
        if (response.ok) {
          dispatch({ type: types.APPLICATION_SUCCESS });
          return;
        } else {
          dispatch({ type: types.APPLICATION_FAILURE });
          dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));

          return logger.error(response.data);
        }
      });
  },

  vote: data => dispatch => {
    dispatch({ type: types.BUDGET_VOTE_SUBMIT });
    return budgetApi
      .vote(data)
      .then(response => {
        if (response.ok) {
          if (response.data.error) {
            dispatch({ type: types.BUDGET_VOTE_ERROR, error: response.data.error });
            return;
          }
          dispatch({ type: types.BUDGET_VOTE_SUCCESS });
          return;
        } else {
          dispatch({ type: types.BUDGET_VOTE_FAILURE });
          if (response.data && response.data.validationErrors && response.data.validationErrors.length > 0) {
            dispatch(notificationActions.showError(response.data.validationErrors[0].errorMessage));  
          } else {
            dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));
          }

          return logger.error(response.data);
        }
      });
  },

  startPhoneNumberVerification: (budgetId, phoneNumber, verificationMethodId) => (dispatch, getState) => {
    return budgetApi
      .startPhoneNumberVerification(budgetId, phoneNumber, verificationMethodId)
      .then(r => {
        if (r.ok) return { error: null, token: r.data.token };
        if (!r.ok && r.data && r.data.message === 'Already voted') return { error: { alreadyVoted: true } };
        dispatch(notificationActions.showError('Rozpoczęcie weryfikacji numeru telefonu nie powiodło się.'));
        return { error: { other: true } };
      })
      .catch(() => {
        dispatch(notificationActions.showError('Rozpoczęcie weryfikacji numeru telefonu nie powiodło się.'));
        return { error: { other: true } };
      });
  },

  suggestVoters: (data, methodId) => (dispatch, getState) => {
    const state = getState();
    return budgetApi
      .suggestVoters(state.budgetVoting.data.id, data, methodId)
      .then(response => {
        if (response.ok) {
          return response.data;
        } else {
          dispatch(notificationActions.showError('Wyszukiwanie nie powiodło się.'));
          return logger.error(response.data);
        }
      });
  },

  openForm: budgetId => dispatch => {
    return dispatch(push(routePaths.budgetForm + budgetId));
  },

  voteManual: (id, data) => dispatch => {
    // todo: get token
    dispatch({ type: types.BUDGET_VOTE_SUBMIT });
    return budgetApi
      .voteManual(id, data)
      .then(response => {
        if (response.ok) {
          if (response.data.error) {
            dispatch({ type: types.BUDGET_VOTE_ERROR, error: response.data.error });
            return;
          }
          dispatch({ type: types.BUDGET_VOTE_SUCCESS });
          return;
        } else {
          dispatch({ type: types.BUDGET_VOTE_FAILURE });
          if (response.data && response.data.validationErrors && response.data.validationErrors.length > 0) {
            dispatch(notificationActions.showError(response.data.validationErrors[0].errorMessage));  
          } else {
            dispatch(notificationActions.showError(`Zapis nie powiódł się ${response.data && response.data.failure ? response.data.failure.message : ''}`));
          }

          return logger.error(response.data);
        }
      });
  },

  confirmVoteError: () => dispatch => dispatch({ type: types.CLEAR_BUDGET_VOTE_ERROR }),

  getReport: (budgetId, applicationId, params) => dispatch => {
    return budgetApi
      .getReport(budgetId, applicationId, params)
      .then(response => {
        if (response.ok) {
          storeBlobAs(response.data, 'Projekt.pdf');

          return dispatch(notificationActions.showSuccess("Wygenerowano wydruk"));
        }

        logger.error(response);
        dispatch(notificationActions.showError("Wystąpił problem podczas generowania wydruku"));
      });
  },
};



// WEBPACK FOOTER //
// ./src/actions/budgetActions.js